import { AppType } from './../../../../common/assets/website-data';
import { CONTACTS, IContact } from './../../../../common/contacts.constants';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Inject, Output } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { Meta } from '../../../../common/Meta';
import { URL } from '../../environments/environment';
import { CanonicalService } from '../shared/services/canonical.service';

@Component({
    selector: 'app-contact-wrapper',
    templateUrl: './contact-wrapper.component.html',

})
export class ContactWrapperComponent implements OnInit {
    public URL = URL;
    playVideo = false;

    get appType() {
        return AppType.chilefirmas;
    }

    @Output() TLD = 'cl';
    @Output() Meta: Meta;
    @Output() MessageFrom = 'ChileFirmas';
    @Output() ContactList: IContact[] = CONTACTS.filter(c => c.country_code === 'cl');

    constructor(
        @Inject(DOCUMENT) private _document: Document,
        private readonly route: ActivatedRoute,
        private readonly _canonical: CanonicalService
    ) {
        this.Meta = new Meta(
            'Contactar con ventas | ChileFirmas',
            'Completa tus datos y en pocos segundos uno de nuestros ejecutivos de venta se comunicará contigo. Descubre todo lo que ChileFirmas tiene para ofrecer.',
            'ChileFirmas',
            this.URL.OPENFACTURA_WEBSITE + '/assets/images/og_haulmer.png',
            'png',
            644,
            374,
            'Contacto con ventas, ChileFirmas'
        );

        this.Meta.addKeyword('contactar ventas');
        this.Meta.addKeyword('ventas');
        this.Meta.addKeyword('atención al cliente');
        this.Meta.addKeyword('centro de soporte');
    }

    ngOnInit() {
        this._canonical.set('contactar-con-ventas');
        this.route.queryParams.subscribe(params => {
            if (params.partner === 'true') {
                this.MessageFrom = 'ChileFirmas - Partner';
            }
        });
    }
}
